module.exports = __webpack_public_path__ + "img/tz.537b1beb.png";